import Man1 from '../assets/avatars/man-1.png'

const avatars: any = {
  man_1: Man1,
}

export const getAvatar = (id: string) => {
  return avatars[id]
}
